<app-nav-bar></app-nav-bar>
<app-language-dropdown
  (passTranslationParent)="changeTranslation($event)"
></app-language-dropdown>
<div class="sura-wrapper flex justify-center">
  <div class="sura-container">
    <ng-container *ngFor="let soora of sooras">
      <div class="search-results">
        <div class="sura" [ngClass]="arabicClass ? 'sura-arabic' : ''">
          <span
            (click)="setCurrentSoora(soora)"
            class="sura-number hover"
            id="verse-{{ soora.SooraId }}"
            >{{ soora.SooraId }}</span
          >
          <p
            [ngClass]="{ 'text-end': arabicClass }"
            class="hover"
            (click)="setCurrentSoora(soora)"
          >
            {{
              arabicClass
                ? soora.Soora.SooraName
                : soora.Soora.ArabicEnglishName
            }}
          </p>
        </div>
      </div>
    </ng-container>
  </div>
  <section
    *ngIf="this.sooras.length > 0"
    class="standalone"
    [ngClass]="{ 'arabic-language': arabicClass }"
  >
    <div class="content">
      <div class="difference-head-top">
        <div class="difference-head">
          <h1>
            {{ currentSoora.SooraId }}.{{
              arabicClass
                ? currentSoora.Soora.SooraName
                : currentSoora.Soora.ArabicEnglishName
            }}
          </h1>
        </div>
      </div>
      <div class="content-standalone">
        <div class="sub-block verse-history">
          <div class="verse-history-title">
            <h4 class="">
              <img src="assets/images/sura_history_20.svg" />{{
                "verseHistory" | translate
              }}
            </h4>
          </div>
          <div class="verse-body">
            <p
              [innerHtml]="
                safeHTML(currentSoora.SooraBackgroundComments[0].Comment)
              "
            ></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
